var _defs, _path, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamMembersTableta(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "24.65 29.233 450.7 441.535",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.571,
    y1: 1.795,
    x2: 0.493,
    y2: 0.379,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1.147,
    x2: 0.5,
    y2: 0.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 2.165,
    x2: 0.5,
    y2: 0.322,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M 182.327 124.478 C 241.451 91.999 327.089 42.427 348.397 114.478 C 369.705 186.53 443.953 287.538 398.808 347.072 C 353.663 406.606 250.97 427.015 172.988 421.805 C 95.006 416.595 86.888 326.222 86.888 326.222 C 86.888 326.222 88.042 294.829 111.902 244.393 C 135.762 193.957 123.204 156.958 182.327 124.478 Z",
    fill: "#ffdc9c",
    transform: "matrix(-0.422618, 0.906308, -0.906308, -0.422618, 582.230896, 129.07785)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "matrix(1, 0, 0, 1, 108.610992, 113.171066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    d: "M55.815,0h0a55.816,55.816,0,0,1,55.816,55.816v0a55.816,55.816,0,0,1-55.816,55.816h0A55.816,55.816,0,0,1,0,55.816v0A55.815,55.815,0,0,1,55.815,0Z",
    transform: "translate(0 55.61)",
    opacity: 0.95,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 51.684,
    height: 2.553,
    transform: "translate(29.974 141.827)",
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 37.043,
    height: 2.553,
    transform: "translate(37.295 149.872)",
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    d: "M69.116,0H83.666a69.115,69.115,0,0,1,69.115,69.115v41.1A69.115,69.115,0,0,1,83.666,179.33H69.115A69.115,69.115,0,0,1,0,110.215v-41.1A69.116,69.116,0,0,1,69.116,0Z",
    transform: "translate(129.997 94.327)",
    opacity: 0.95,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(199.269 200.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 12.117,
    height: 2.244,
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(153.265 220.685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 70.51,
    height: 4.345,
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 57.018,
    height: 4.345,
    transform: "translate(0 20.861)",
    fill: "#96bfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 33.426,
    height: 4.345,
    transform: "translate(0 10.43)",
    fill: "#96bfe6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(154.479 112.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M2077.635,763.9V766.1h12.92v12.126h2.194V763.9Zm-87.743,14.321h2.194V766.1h12.921V763.9h-15.115ZM2090.555,840.8v12.131h-12.92v2.194h15.115V840.8Zm-98.469,0h-2.194v14.325h15.115v-2.194h-12.921Z",
    transform: "translate(-1989.892 -763.902)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(237.574 220.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M2395.443,1300.784a12.922,12.922,0,1,1,12.922-12.922A12.936,12.936,0,0,1,2395.443,1300.784Zm0-23.343a10.421,10.421,0,1,0,10.421,10.421A10.432,10.432,0,0,0,2395.443,1277.441Z",
    transform: "translate(-2382.521 -1274.94)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(6.227 8.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M2417.815,1325.431l-5.87-5.871,1.768-1.768,4.1,4.1,5.75-5.75,1.77,1.768Z",
    transform: "translate(-2411.945 -1316.144)",
    fill: "#4598e6"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 75.244,
    height: 64.559,
    transform: "translate(18.194 59.784)",
    opacity: 0.95,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 82.016,
    height: 73.866,
    rx: 36.933,
    transform: "translate(122.598 14.271)",
    opacity: 0.95,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(160.042 74.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 6.505,
    height: 1.205,
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(135.997 27.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M1949.669,364.3v1.178h6.936v6.51h1.178V364.3Zm-47.1,7.688h1.178v-6.51h6.936V364.3h-8.114Zm54.038,33.59v6.512h-6.936v1.178h8.115v-7.69Zm-52.861,0h-1.178v7.69h8.114v-1.178h-6.936Z",
    transform: "translate(-1902.567 -364.297)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(51.472 129.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 8.688,
    height: 1.609,
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(18.94 67.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M1412.381,551.257v1.573h9.265v8.7h1.573V551.257Zm-62.914,10.269h1.573v-8.7h9.265v-1.573h-10.838Zm72.179,44.867v8.7h-9.265v1.574h10.838V606.392Zm-70.606,0h-1.573v10.272h10.838v-1.574h-9.265Z",
    transform: "translate(-1349.467 -551.257)",
    fill: "#4598e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(155.393 72.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(0 49.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M2091.345,871.7h-14.494c-.953-6.939-2.126-14.861-2.126-14.861s-.586,6.538-1.3,14.861h-58c-.529-7.485-1.166-13.086-1.4-13.2-.333-.167-2.4,6.474-4.119,13.2h-15.7c4.039-17.395,11.57-45.3,15.924-46.975,6.2-2.384,31.476-10.174,31.476-10.174h14.425s25.633,7.313,28.017,15.264C2085.951,836.153,2090.133,857.047,2091.345,871.7Z",
    transform: "translate(-1994.212 -814.553)",
    fill: "#e65353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(39.157 3.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M2195.351,592.969s13.469,2.122,11.418,23.2-13.939,19.347-14.733,19.325-11.934.384-12.8-25.346C2179.233,610.144,2178.854,591.118,2195.351,592.969Z",
    transform: "translate(-2179.232 -592.842)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(43.626 37.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M2218.285,756.515s-.369,8.668.47,10.544-11.116,7.9-18.406,1.187c0,0,1.761-9.42,1.271-12.759S2218.285,756.515,2218.285,756.515Z",
    transform: "translate(-2200.349 -754.23)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(66.119 19.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M2307.413,672.329s1.475-1.576,2.016.019-2.289,8.722-2.1,9.041c0,0-.269.619-.624.278S2307.413,672.329,2307.413,672.329Z",
    transform: "translate(-2306.629 -671.635)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(37.214 19.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M2172.147,670.98s-1.445-1.6-2.016-.019,2.119,8.764,1.928,9.08c0,0,.258.624.618.29S2172.147,670.98,2172.147,670.98Z",
    transform: "translate(-2170.052 -670.261)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(37.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M2201.177,602.182l-1.928,2.578s.055-5.652-.255-6.538-.783-3.593-1.042-4.232-11.567-3.807-21.555.925c0,0,.439,4.064-.518,4.426s-.488,6.619-.488,6.619l-1.585-1.789s-2.427-16.214-1.828-17.9,2.509-11.85,23-5.819c0,0,6.388-1.353,7.671,3.057S2201.177,602.182,2201.177,602.182Z",
    transform: "translate(-2171.884 -578.557)",
    fill: "#d98b52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(43.62 49.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M2218.729,814.607s3.039.649-9.678,12.836c0,0-9.02-9.978-8.728-11.649S2218.729,814.607,2218.729,814.607Z",
    transform: "translate(-2200.316 -814.542)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(52.354 48.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M2241.587,820.909l3.471,5.935,10.3-17.48-4.458-3.109Z",
    transform: "translate(-2241.587 -806.254)",
    fill: "#b84343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(39.157 49.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M2192.429,825.58l-8.422-13.4-4.775,3.068,8.561,16.267Z",
    transform: "translate(-2179.232 -812.179)",
    fill: "#b84343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(49.156 62.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M2227.064,912.448c.1,1.977.149,4.4.155,7.123h-.477c-.005-2.711-.052-5.13-.155-7.1-.781-14.868,2.821-32.958,2.844-37.2l.465.092C2229.873,879.606,2226.283,897.644,2227.064,912.448Z",
    transform: "translate(-2226.477 -875.274)",
    fill: "#b84343"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M2212.281,780.808a8.968,8.968,0,0,0,7.72,2.481c4.521-.9,6.528-2.972,6.528-2.972a8.4,8.4,0,0,1-7.01,4.885C2214.293,785.611,2212.281,780.808,2212.281,780.808Z",
    transform: "translate(-2166.129 -737.617)",
    fill: "#c78d71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(21.079 44.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(22.36 15.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M1467.267,525.1a.146.146,0,0,1-.03,0c-.3-.074-.785-1.531-.879-1.822-.021-.08-.069-.227-.135-.43-.378-1.166-1.26-3.9-.916-4.944.108-.33.278-.521.5-.568.483-.1,1.036.514,1.059.54l.011.013,0,.018c.125,1.149.738,6.893.474,7.157A.126.126,0,0,1,1467.267,525.1Zm-1.346-7.667a.461.461,0,0,0-.089.008c-.184.038-.325.2-.42.495-.333,1.012.574,3.819.917,4.875.066.2.114.352.136.432a5.056,5.056,0,0,0,.8,1.746s.008,0,.016-.006a55.041,55.041,0,0,0-.5-7.048A1.51,1.51,0,0,0,1465.921,517.435Z",
    transform: "translate(-1465.228 -517.324)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(18.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M1464.039,445.766s7.415-.777,10.086,6.383,5.187,9.5,5.5,13.266c1.274,15.214,8.378,11.773,6.38,20.542s-3.382,10.1-3.382,10.1l-16.986-3.33-17.207.055s6.732-3.362,5.233-10.522-5.233-18.9-3.124-26.889S1459.608,446.376,1464.039,445.766Z",
    transform: "translate(-1448.433 -445.741)",
    fill: "#16202e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(43.311 15.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M1564.379,525.1a.127.127,0,0,1-.09-.039c-.264-.264.349-6.009.474-7.157l0-.018.011-.013c.024-.026.576-.641,1.06-.54.225.047.395.238.5.568.345,1.047-.539,3.778-.917,4.944-.065.2-.113.349-.134.427-.094.293-.576,1.75-.88,1.824A.132.132,0,0,1,1564.379,525.1Zm.492-7.166a54.9,54.9,0,0,0-.5,7.049c.007.007.01.006.015,0a5.057,5.057,0,0,0,.8-1.748c.021-.078.069-.225.135-.43.342-1.056,1.25-3.863.917-4.875-.1-.29-.237-.456-.421-.494C1565.428,517.363,1564.952,517.849,1564.871,517.936Z",
    transform: "translate(-1564.224 -517.323)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(0 38.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M1428.849,657.316h-10.584c-2.194-4-3.978-7.128-3.978-7.128a31.978,31.978,0,0,0-2.533,7.128h-35.631a30.769,30.769,0,0,1-.463-7.456s-1.9,3.441-4.114,7.456h-11.971c3.177-5.948,9.129-16.779,10.482-18.19,1.7-1.78,11.544-8.584,18.573-10.8s11.029-.077,11.029-.077a83.279,83.279,0,0,1,13.9,3.948C1416.181,633.232,1423.431,646.621,1428.849,657.316Z",
    transform: "translate(-1359.576 -627.313)",
    fill: "#faa146"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(23.692 4.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M1483.218,465.346s9.819,1.417,8.382,15.913-10.1,13.345-10.682,13.333-8.695.3-9.4-17.387C1471.521,477.205,1471.193,464.125,1483.218,465.346Z",
    transform: "translate(-1471.52 -465.266)",
    fill: "#8e4f3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(28.572 30.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M1505.759,589.232s-.608,7.54.844,9.8-1.242,5.325-6.793,4.276-5.228-4.2-5.228-4.2,1.554-4.653,1.1-8.378S1505.759,589.232,1505.759,589.232Z",
    transform: "translate(-1494.578 -588.574)",
    fill: "#8e4f3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(22.716 1.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M1478.459,462.062s4.588,4.823,6.719,7.266,2.376,7.16,2.376,7.16,3.59-4.385,2.089-9.491-5.054-15.042-14.045-11.989-9.325,16.485-8.271,23.146C1467.328,478.153,1471.364,463.449,1478.459,462.062Z",
    transform: "translate(-1466.909 -454.436)",
    fill: "#16202e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(27.175 38.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M1504,629.723s-6.81,17.248-10.949,20.245c0,0-5.437-17.591-5.057-20.167C1488,629.8,1496.2,626.588,1504,629.723Z",
    transform: "translate(-1487.98 -628.35)",
    fill: "#8e4f3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(19.298 35.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M1460.272,615.131s-12.14,10.8-8.99,17.54c2.689,5.751,12.223,2.224,10.65-3.8A67.812,67.812,0,0,1,1460.272,615.131Z",
    transform: "translate(-1450.76 -615.131)",
    fill: "#16202e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(30.397 31.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M1503.2,597.214a8.578,8.578,0,0,0,8.256-.943,5.314,5.314,0,0,1-4.128,2.668A4.068,4.068,0,0,1,1503.2,597.214Z",
    transform: "translate(-1503.202 -596.27)",
    fill: "#633029"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(143.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(0 37.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M1952.751,412.207s-4.026,15.152-4.866,18.566a28.411,28.411,0,0,1-2.082,4.833c-.007.014-.014.029-.026.047a3.844,3.844,0,0,0-.377,1.231c-.163,1.263.323,2.259-.517,3.758l-.152.63h-7.969c.93-2.762,2.111-6.278,3.056-9.109.793-2.389,1.419-4.29,1.586-4.841.492-1.644,2.3-6.966,3.833-10.5.536-1.231,2.6-2.448,4.428-3.327C1951.3,412.718,1952.751,412.207,1952.751,412.207Z",
    transform: "translate(-1936.762 -412.207)",
    fill: "#323657"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(10.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M1986.418,249.839s-2.541-16.434,11.071-16.13,13.428,8.429,13.186,16.494-5.458,7.459.425,18.677-5.094,11.219-5.094,11.219l-8.517-11.7Z",
    transform: "translate(-1986.23 -233.704)",
    fill: "#fccca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(10.627 1.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M1996.585,240.46s-9.217,1.455-9.581,14.553,2.486,15.888,10.552,13.159,10.612-16.434,10.794-18.556S2009.016,238.884,1996.585,240.46Z",
    transform: "translate(-1986.973 -240.269)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(2.098 33.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M1981,405.264c.032,4.508-5.148,15.29-5.949,18.62-.094.388-.2.746-.3,1.083H1949.6c-.13-1.553-.253-2.882-.315-3.631-.2-2.462-2.693-7.766-2.61-10.235.087-2.516,1.322-4.689,3.049-7.375.536-.833,1.1-1.68,1.662-2.505a47.561,47.561,0,0,1,4.558-5.967,14.592,14.592,0,0,1,1.836-1.463l0,0a8.48,8.48,0,0,1,1.89-1l7.922-1.267s4.939,1.789,7.781,2.451C1975.377,393.975,1980.919,394.786,1981,405.264Z",
    transform: "translate(-1946.674 -391.524)",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(4.379 35.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M1966.283,402.216l-4.592,7.237-4.238,6.679c.01-.036.292-1.047.771-3.976.091-.556.189-1.181.294-1.881a4.94,4.94,0,0,1,.133-.616h0c1.814-4.182,7.422-7.335,7.627-7.44Z",
    transform: "translate(-1957.452 -402.216)",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(14.548 23.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M2017.348,343.521c-.8,1.509-1.642,10.874-1.642,10.874s-11.274,4.261-10.12,1.851a9.221,9.221,0,0,0,.688-3.737,18.1,18.1,0,0,0-.125-2.275c-.029-.246-.052-.388-.052-.388S2018.148,342.011,2017.348,343.521Z",
    transform: "translate(-2005.504 -343.328)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(10.657 1.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M1992.939,249.037s4.73,7.7,9.035,10.733,2.122,5.458,2.122,5.458,11.234-23.65.554-25.287-17.229-1.759-17.533,14.25C1987.117,254.191,1991.968,248.916,1992.939,249.037Z",
    transform: "translate(-1987.117 -239.225)",
    fill: "#fccca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(15.194 29.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M2014.982,371.4c-1.731,2.552-6.3,3.24-6.3,3.24h0a18.126,18.126,0,0,0-.125-2.275C2011.492,372.933,2014.982,371.4,2014.982,371.4Z",
    transform: "translate(-2008.554 -371.402)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M1961.541,409.618h0a9.464,9.464,0,0,0-.445,2.547l1.66-2.506s2.966-4.252,3.982-5.358a16.873,16.873,0,0,1,2.412-2.074S1963.314,405.031,1961.541,409.618Z",
    transform: "translate(-1955.945 -366.561)",
    fill: "#ebeeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M2059.626,416.885s7.237-2.838,9.377-3c0,0-1.456-11.619-8.563-10.388S2059.626,416.885,2059.626,416.885Z",
    transform: "translate(-2031.596 -367.488)",
    fill: "#e55353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M1993.624,392.7s-5.312,8.168-3.514,8.882,11.532-.952,15.671-8.711C2005.78,392.87,1999.592,389.7,1993.624,392.7Z",
    transform: "translate(-1978.526 -358.032)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M2042.507,406.515c-.369,6.4-2.187,12.48-3.686,18.055-.218.808-.427,1.608-.623,2.393h-14.732c-.036-2.209-.029-4.156.04-5.782.742-17.777,6.376-27.125,6.376-27.125s1.8.6,6.977,2.071c3.548,1,4.888,5.518,5.376,8.255a.218.218,0,0,1,.008.033A19.443,19.443,0,0,1,2042.507,406.515Z",
    transform: "translate(-2005.099 -360.12)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M1958.956,397.529a42.524,42.524,0,0,0-2.191,4.4,47.743,47.743,0,0,0-4.109,17.317,101.793,101.793,0,0,1-1.18,10.46h-2.94a46.669,46.669,0,0,0-1.618-9.109c-.4-1.43-.771-2.5-.97-3.175-.938-3.19,2.06-7.437,3.063-8.957S1952.421,399.962,1958.956,397.529Z",
    transform: "translate(-1943.862 -362.857)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M2072.36,433.838h-7.911a10.492,10.492,0,0,0-.467-2.393c-1.437-5.109-5.691-15.054-5.691-15.054s-6.365-10.4-.333-13.052,8.628,4.757,9.438,7.918a.23.23,0,0,1,.008.033C2067.6,412.046,2071.195,425.739,2072.36,433.838Z",
    transform: "translate(-2030.26 -366.994)",
    fill: "#323657"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMembersTableta);
export default __webpack_public_path__ + "static/media/TeamMembersTableta.5ca368063c4c404e93d5c313b7784e48.svg";
export { ForwardRef as ReactComponent };